import { blinkConstants } from '@thoughtspot/blink-constants';
import { getDocumentationLink } from '@thoughtspot/session-service';
export const HOST_REGEX = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
export const IP_REGEX = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const PORT_REGEX = /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
export var LearnMore;
(function (LearnMore) {
    LearnMore["SMTP"] = "smtp";
    LearnMore["SECURITY"] = "security";
    LearnMore["SSL"] = "ssl";
    LearnMore["SSH"] = "ssh";
    LearnMore["NAS"] = "nas";
    LearnMore["SNAPSHOT"] = "snapshot";
    LearnMore["HELP_CUSTOMIZATION"] = "helpCustomization";
    LearnMore["SAML"] = "saml";
    LearnMore["INTERNAL_AUTH"] = "internalAuth";
    LearnMore["ACTIVE_DIRECTORY"] = "activeDirectory";
    LearnMore["STATUS_PORTAL"] = "statusPortal";
})(LearnMore || (LearnMore = {}));
export var Mode;
(function (Mode) {
    Mode["EDIT"] = "edit";
    Mode["VIEW"] = "view";
})(Mode || (Mode = {}));
export var ActionButtons;
(function (ActionButtons) {
    ActionButtons["BACK"] = "BACK";
    ActionButtons["SAVE"] = "SAVE";
    ActionButtons["DELETE"] = "DELETE";
    ActionButtons["CANCEL"] = "CANCEL";
    ActionButtons["EDIT"] = "EDIT";
    ActionButtons["EDIT_NAS"] = "EDIT_NAS";
    ActionButtons["EDIT_SNAPSHOT"] = "EDIT_SNAPSHOT";
    ActionButtons["ADD"] = "ADD";
})(ActionButtons || (ActionButtons = {}));
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["LEARN_MORE"] = "LEARN_MORE";
    TranslationsKeys["BACK_MODAL_TITLE"] = "smtp.backModal.title";
    TranslationsKeys["BACK_MODAL_LEAVE"] = "smtp.backModal.leave";
    TranslationsKeys["MODAL_CANCEL_BTN"] = "tscli.ui.confirmationModal.cancelBtn.label";
    TranslationsKeys["MODAL_DELETE_BTN"] = "Delete";
    TranslationsKeys["MODAL_CONTENT"] = "tscli.ui.confirmationModal.content";
    TranslationsKeys["DELETECONFIRMATION_MODAL_TITLE"] = "smtp.deleteModal.title";
    TranslationsKeys["DELETECONFIRMATION_MODAL_CONTENT"] = "smtp.deleteModal.body";
    TranslationsKeys["HOST_NOTREACHABLE_MESSAGE"] = "smtp.hostNotReachable.message";
    TranslationsKeys["HOST_NOTREACHABLE_TITLE"] = "smtp.hostNotReachable.title";
    TranslationsKeys["CLOSE_BUTTON"] = "CLOSE";
    TranslationsKeys["CONFIGURED"] = "configStatus.configured";
    TranslationsKeys["UNCONFIGURED"] = "smtp.configStatus.notConfigured";
    TranslationsKeys["STATUS_LABEL"] = "smtp.form.status";
    TranslationsKeys["FROM_RELAY_HOST_LABEL"] = "smtp.form.relay_host";
    TranslationsKeys["FROM_PORT"] = "smtp.form.port";
    TranslationsKeys["VALID_FIELDNAME"] = "smtp.valid.fieldName";
    TranslationsKeys["YES"] = "smtp.form.yes";
    TranslationsKeys["NO"] = "smtp.form.no";
    TranslationsKeys["IS_HOST_REACHABLE_LABEL"] = "smtp.form.isHostReachable";
    TranslationsKeys["FROM_DOMAIN"] = "smtp.form.from_name";
    TranslationsKeys["FROM_USERNAME"] = "smtp.form.from_email";
    TranslationsKeys["FROM_AUTH_REQUIRED_LABEL"] = "smtp.form.authentication";
    TranslationsKeys["USERNAME_LABEL"] = "smtp.form.username";
    TranslationsKeys["FROM_PASSWORD_LABEL"] = "smtp.form.password";
    TranslationsKeys["CANCEL_BUTTON"] = "smtp.actions.cancel";
    TranslationsKeys["DELETE_SSL_CONFIRMATION_MODAL_TITLE"] = "security.deleteSslConfirmationModalTitle";
    TranslationsKeys["DELETE_SSL_CONFIRMATION_MODAL_CANCEL_BTN"] = "modal.cancel";
    TranslationsKeys["DELETE_SSL_CONFIRMATION_MODAL_CONFIRM_BTN"] = "DELETE";
    TranslationsKeys["DELETE_SSL_CONFIRMATION_MODAL_CONTENT"] = "security.deleteSslConfirmationModalContent";
    TranslationsKeys["SECURITY_BACK_CONFIRMATION_MODAL_TITLE"] = "security.backModalTitle";
    TranslationsKeys["SECURITY_BACK_CONFIRMATION_MODAL_CONTENT"] = "security.backModalContent";
    TranslationsKeys["SECURITY_BACK_CONFIRMATION_MODAL_LEAVE_BTN"] = "security.backModalLeaveButton";
    TranslationsKeys["SECURITY_BACK_CONFIRMATION_MODAL_CANCEL_BTN"] = "security.backModalCancelButton";
    TranslationsKeys["UNCONFIGURED_STATUS_LABEL"] = "security.unconfiguredStatusLabel";
    TranslationsKeys["SSL_STATUS"] = "security.sslStatus";
    TranslationsKeys["SIGNATURE_ALGORITHM"] = "security.signatureAlgorithm";
    TranslationsKeys["KEY_TYPE"] = "security.keyType";
    TranslationsKeys["SIGNING_ALGORITHM"] = "security.signingAlgorithm";
    TranslationsKeys["TLS_VERSION"] = "security.tlsVersion";
    TranslationsKeys["PRIVATE_KEY"] = "security.privateKey";
    TranslationsKeys["SSL_CERTIFICATE_BUNDLE"] = "security.sslCertificateBundle";
    TranslationsKeys["ORGANIZATION"] = "security.organization";
    TranslationsKeys["COUNTRY"] = "security.country";
    TranslationsKeys["STATE"] = "security.state";
    TranslationsKeys["COMPANY_NAME"] = "security.companyName";
    TranslationsKeys["EXPIRY_DATE"] = "security.expiryDate";
    TranslationsKeys["REVERSE_SSH_TUNNELING"] = "security.reverseSshTunneling";
    TranslationsKeys["SSL_SIGNING_ALGORITHM_FORM_ERROR"] = "security.ssl.formError.signing_algorithm";
    TranslationsKeys["SSL_FILE_INPUT_PLACEHOLDER"] = "security.ssl.fileInput.placeholder";
    TranslationsKeys["SSL_FILE_INPUT_INVALID_FILE_FORM_ERROR"] = "security.ssl.formError.fileInput.inValidFile";
    TranslationsKeys["SSL_FILE_INPUT_FILE_SIZE_FORM_ERROR"] = "security.ssl.formError.fileInput.fileSize";
    TranslationsKeys["SAML_IP_OF_SERVER"] = "saml.mapping.IPofServer";
    TranslationsKeys["SAML_IP_OF_SERVER_HELP_TEXT"] = "saml.form.helptext.IPofServer";
    TranslationsKeys["SAML_IP_OF_SERVER_PLACEHOLDER"] = "saml.form.placeholder.IpOfServer";
    TranslationsKeys["SAML_PROTOCOL"] = "saml.mapping.Protocol";
    TranslationsKeys["SAML_PORT"] = "saml.mapping.Port";
    TranslationsKeys["SAML_UNIQUE_SERVICE_NAME"] = "saml.mapping.UniqueServiceName";
    TranslationsKeys["SAML_UNIQUE_SERVICE_NAME_HELP_TEXT"] = "saml.form.helptext.UniqueServiceName";
    TranslationsKeys["SAML_SKEW_TIME"] = "saml.mapping.SkewTimeinSeconds";
    TranslationsKeys["SAML_SKEW_TIME_HELP_TEXT"] = "saml.form.helptext.SkewTimeinSeconds";
    TranslationsKeys["SAML_IDP_METADATA"] = "saml.mapping.MetaData";
    TranslationsKeys["SAML_AUTO_ADD_SAML_USER"] = "saml.form.AutoAddSAMLUserinThoughtSpot";
    TranslationsKeys["SAML_ERROR_IP_OF_SERVER"] = "error.saml.ipOfServer";
    TranslationsKeys["SAML_ERROR_PROTOCOL"] = "error.saml.protocol";
    TranslationsKeys["SAML_ERROR_PORT"] = "error.saml.port";
    TranslationsKeys["SAML_ERROR_UNIQUE_SERVICE_NAME"] = "error.saml.uniqueServiceName";
    TranslationsKeys["SAML_ERROR_SKEW_TIME"] = "error.saml.skewTime";
    TranslationsKeys["SAML_ERROR_IDP_METADATA"] = "error.saml.idpMetaDataXmlFile";
    TranslationsKeys["SAML_INVALID_ERROR_IP_OF_SERVER"] = "error.saml.invalidIpOfServer";
    TranslationsKeys["SAML_INVALID_ERROR_PROTOCOL"] = "error.saml.invalidProtocol";
    TranslationsKeys["SAML_INVALID_ERROR_PORT"] = "error.saml.invalidPort";
    TranslationsKeys["SAML_ERROR_NONE_SELECTED_ADD_USER"] = "error.saml.noneSelectedAddSamlUser";
    TranslationsKeys["SAML_INVALID_ERROR_SKEW_TIME"] = "error.saml.invalidSkewTime";
    TranslationsKeys["SAML_INVALID_ERROR_IDP_METADATA"] = "error.saml.invalidIdpMetaDataXmlFile";
    TranslationsKeys["SAML_TS_METADATA"] = "saml.mapping.thoughtSpot.certificate";
    TranslationsKeys["DOWNLOAD_BUTTON_TEXT"] = "download.btnText";
    TranslationsKeys["SAML_REMOVE_CONFIRM_DESC"] = "saml.removeConfirmationDescription";
    TranslationsKeys["REMOVE_CONFIRMATION_TEXT"] = "removeConfirmationText";
    TranslationsKeys["INTERNAL_AUTH_HEADING"] = "internalAuth.heading";
    TranslationsKeys["INTERNAL_AUTH_STATUS"] = "configStatus.status";
    TranslationsKeys["AD_MAPPING_URL"] = "ad.mapping.URL";
    TranslationsKeys["AD_MAPPING_DOMAIN"] = "ad.mapping.Domain";
    TranslationsKeys["AD_MAPPING_SEARCH_BASE"] = "ad.mapping.SearchBase";
    TranslationsKeys["AD_MAPPING_AUTO_ADD_USER"] = "ad.mapping.AutoAddADUserinThoughtSpot";
    TranslationsKeys["AD_MAPPING_SSL_REQUIRED"] = "ad.mapping.SSLRequired";
    TranslationsKeys["AD_MAPPING_URL_REQUIRED_ERROR"] = "error.ad.url";
    TranslationsKeys["AD_MAPPING_DOMAIN_REQUIRED_ERROR"] = "error.ad.domain";
    TranslationsKeys["AD_MAPPING_SEARCH_BASE_REQUIRED_ERROR"] = "error.ad.searchBase";
    TranslationsKeys["AD_MAPPING_SSL_CERT_REQUIRED_ERROR"] = "error.ad.sslCertificate";
    TranslationsKeys["AD_MAPPING_CERT_ALIAS_REQUIRED_ERROR"] = "error.ad.certificateAlias";
    TranslationsKeys["AD_MAPPING_PORT_INVALID_ERROR"] = "error.ad.invalidPort";
    TranslationsKeys["AD_MAPPING_SSL_CERTIFICATE_LABEL"] = "ad.mapping.SSLCertificate.label";
    TranslationsKeys["AD_MAPPING_SSL_CERTIFICATE_UPLOAD"] = "ad.mapping.SSLCertificate.upload";
    TranslationsKeys["AD_MAPPING_CERTIFICATE_ALIAS"] = "ad.mapping.CertificateAlias";
    TranslationsKeys["CONFIRM_YES"] = "confirm.yes";
    TranslationsKeys["CONFIRM_NO"] = "confirm.no";
    TranslationsKeys["AD_REMOVE_CONFIRM_DESC"] = "ad.removeConfirmationDescription";
})(TranslationsKeys || (TranslationsKeys = {}));
export const LearnMoreConfig = {
    smtp: {
        url: getDocumentationLink(blinkConstants.adminLearnMore.smtp),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    security: {
        url: '',
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    ssl: {
        url: getDocumentationLink(blinkConstants.adminLearnMore.ssl),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    ssh: {
        url: getDocumentationLink(blinkConstants.adminLearnMore.ssh),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    nas: {
        url: getDocumentationLink(blinkConstants.adminLearnMore.nas),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    snapshot: {
        url: getDocumentationLink(blinkConstants.adminLearnMore.snapshot),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    helpCustomization: {
        url: getDocumentationLink(blinkConstants.adminLearnMore.helpCustomization),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    saml: {
        url: getDocumentationLink(blinkConstants.docsUrl.configureSAML),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    internalAuth: {
        url: getDocumentationLink(blinkConstants.docsUrl.internalAuth),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    activeDirectory: {
        url: getDocumentationLink(blinkConstants.docsUrl.ldapConfigAD),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
    statusPortal: {
        url: getDocumentationLink(blinkConstants.docsUrl.statusPortal),
        text: TranslationsKeys.LEARN_MORE,
        newWindow: true,
    },
};
//# sourceMappingURL=constants.js.map